module.exports = __webpack_public_path__ + "static/img/woman-background.0375070.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/woman-background.jpg
// module id = 11UF
// module chunks = 1